module.exports = "/_next/static/images/c971ba652fb9c9862f2da174462e6c90-roxinho-single-lg@1x.jpg.webp";